module.exports = __webpack_public_path__ + "static/media/no-ava.b66e5964.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/no-ava.png
// module id = 462
// module chunks = 0